export const COLOR_SPINNER = 'var(--primary-color)';
export const SPINNER_DEFAULT = 'three-bounce';
